import React from 'react'
import DefaultForm from '../../../ui/forms/default-form'
import { hasAvailableAction } from '../../../ui/gov-actions'
import { dayFormat } from '../../../week'
import { ChildSubmissionFields, ChildSubmissionDone } from './fields'

const available = record => hasAvailableAction(record, 'run_submissions')

const formEndPoint = ({ service_id, service_type }) =>
  process.env.REACT_APP_API_HOST + `/api/${service_type}/${service_id}/session-reports/submit`

const formValue = 'run_submissions'

const actionForm = ({ service_id, service_type, record, start_date }) => ({ handleSuccess }) => (
  <DefaultForm
    url={formEndPoint({ service_id, service_type })}
    value={formValue}
    label="Create or Update Submissions for this child"
    formOptions={{
      defaultValues: {
        week_start: dayFormat(start_date),
        child_id: record.child_id,
        late_submission_reason: undefined,
      },
    }}
    handleSuccess={payload => {
      return handleSuccess(
        { [formValue]: <ChildSubmissionDone errors={payload.errors} /> },
        formValue
      )
    }}
    formComponent={ChildSubmissionFields}
  />
)

const runSubmissionsForChild = ({
  record,
  service_id,
  service_type,
  refresh_session_reports,
  start_date,
}) =>
  available(record)
    ? {
      label: 'Run Submissions',
      value: formValue,
      actionForm: actionForm({ service_id, service_type, record, start_date }),
      onComplete: refresh_session_reports,
    }
    : null

export default runSubmissionsForChild



// WEBPACK FOOTER //
// ./src/session-summaries/details/run-submissions/index.js